module.exports = __webpack_public_path__ + "img/news-gallery-03.png?6bacd8226439b3e67777bdddc46472ed";